import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

function checkPhone(rule, value, cb) {
	const reg = /^1(3|4|5|6|7|8|9)\d{9}$/

	if (!value) {
		cb(new Error('请输入手机号码'))
	} else if (!reg.test(value)) {
		cb(new Error('请输入正确的手机号码'))
	} else {
		cb()
	}
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}
	const hasBeneficiary = !(
		injured.beneficiary &&
		['0', ''].includes(injured.beneficiary.hasBeneficiary)
	)

	let beneficiaryList = []
	if (injured.beneficiary && injured.beneficiary.beneficiaryList.length) {
		beneficiaryList = injured.beneficiary.beneficiaryList
	}

	const modal = [
		{
			label: '人员类型',
			value: '',
			key: 'beneficiaryType',
			type: 'select',
			selectOption: setting.beneficiarytypeList,
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '姓名',
			value: '',
			key: 'name',
			type: 'text',
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					max: 20,
					message: '长度不能超过20位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '证件类型',
			value: '',
			key: 'certificateType',
			type: 'select',
			selectOption: setting.idTypeList,
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '证件号',
			value: '',
			key: 'certificateNo',
			type: 'text',
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 5,
		},
		{
			label: '年龄',
			value: '',
			key: 'age',
			type: 'text',
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					pattern: /^\d{0,3}$/,
					message: '长度不能超过3位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系电话',
			value: '',
			key: 'phone',
			type: 'text',
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 4,
			rules: [
				{
					validator: checkPhone,
					trigger: 'blur',
				},
			],
		},
	]

	const list = beneficiaryList.map((item, index) => {
		const valArr = [
			item.beneficiaryType,
			item.name,
			item.certificateType,
			item.certificateNo,
			item.age,
			item.phone,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			return {
				...moadlItem,
				value: valArr[valIndex],
			}
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '监护/受益人信息',
		key: 'beneficiary.beneficiaryList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		beneficiary: {
			hasBeneficiary: hasBeneficiary,
		},
	}

	return obj
}
